import { combineReducers } from 'redux';

export const ui = (
  state = {
    windowWidth: window.innerWidth,
    isMobile: matchMedia('(max-width: 800px)').matches,
  },
  action
) => {
  switch (action.type) {
    case 'SELECTED_SCHOOL:SET':
      return {
        ...state,
        ...action.payload,
      };
    case 'APP:WINDOW_RESIZE':
      return {
        ...state,
        windowWidth: window.innerWidth,
        isMobile: matchMedia('(max-width: 800px)').matches,
      };
    default:
      return state;
  }
};

export default combineReducers({
  ui,
});



// WEBPACK FOOTER //
// ./src/reducers.js